// TermsBumpMount — observerar auth-state och visar TermsBumpDialog
// när inloggad user inte har accepterat senaste TERMS/PRIVACY-versionen.
// Mountas i App.tsx. (#50)

import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { needsReAccept, recordAcceptance } from '@/lib/legalVersions';
import { TermsBumpDialog } from './TermsBumpDialog';

export function TermsBumpMount() {
  const { user, isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !user) {
      setOpen(false);
      return;
    }
    // Kolla en gång per session-mount.
    setOpen(needsReAccept(user.id));
  }, [isAuthenticated, user]);

  if (!user) return null;

  return (
    <TermsBumpDialog
      open={open}
      onAccept={() => {
        recordAcceptance(user.id);
        setOpen(false);
      }}
    />
  );
}
